export const fetchAndSortBlogs = async () => {
    const response = await fetch('https://raw.githubusercontent.com/ubaidbutt/my-blogs/main/metadata.json');
    if (!response.ok) throw new Error('Failed to fetch blogs');
    const data = await response.json();

    return data.sort((a, b) => {
        const [yearA, monthA, dayA] = a.created_date.split('-');
        const [yearB, monthB, dayB] = b.created_date.split('-');

        const dateA = new Date(yearA, monthA - 1, dayA);
        const dateB = new Date(yearB, monthB - 1, dayB);

        return dateB - dateA;
    });
};

export const topTrendingBlogs = async () => {
    const sortedBlogs = await fetchAndSortBlogs();
    return sortedBlogs.filter((blog) => blog.special)
}